import { Injectable } from "@angular/core";
import { IProduct } from "../../product-selection-modal/models/product-list.model";
import { v4 as uuidv4 } from "uuid";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";

@Injectable({
    providedIn: "root",
})
export class ProductListingDataBuilderService {
    constructor(private utilityService: UtilityService) {}

    transformOpportunityProductsToQuotationFormat(products: any[], discountOptions: any[], additionalFees: any[]): IProduct[] {
        return products.map((product) => {
            const unit = product?.uom?.find((uom) => uom.unitOfMeasureId == product.uomId);
            const bundleDetails = product?.opportunityBundleProducts ? this.convertBundleProductsToDetails(product, discountOptions, additionalFees) : [];

            return {
                id: product?.productId,
                uuid: uuidv4(),
                itemNo: product?.itemNo ?? "",
                description: product?.description ?? "",
                uom: product?.uom ?? null,
                unit: unit ?? null,
                availabel: product?.product?.availableQty ?? 0,
                ordQty: product?.qty ?? 0,
                bundleQty: product?.opportunityBundleProducts?.length ?? 0,
                originalQty: 1,
                cost: product?.price,
                baseprice: product?.price,
                price: product?.price,
                originalprice: product?.price,
                accountPriceTier: product?.accountProductPriceTiers ?? [],
                isCustom: product?.isCustom ?? false,
                discountTypeName: product?.discountTypeName ?? "",
                selectedTierId: product?.selectedtierId ?? 0,
                locationId: product?.warehouseId ?? 0,
                typeId: product?.productTypeId ?? 0,
                discountType: product?.discountId ? discountOptions?.find((d) => d.id == product?.discountId) : null,
                discount: product?.discountRate ?? 0,
                discountAmount: product?.discountAmount ?? 0,
                taxType: null,
                taxAmount: 0,
                bundleDetails: bundleDetails,
                allBundleProducts: bundleDetails,
                invoiceProductSerialDetails: [],
                totalAvailInSelectedWareHouse: 0,
                totalQuantity: product?.totalQty ?? 0,
                productCategory: product?.productCategory || [],
                addQty: product?.addQty || 0,
                costPrice: product?.costPrice ?? 0,
                totalCostPrice: product?.totalCostPrice ?? 0,
                trackingEnabled: product?.isTrackingRequired ?? false,
                warehouseId: product?.warehouseId ?? 0,
                binDetails: product?.binDetail ?? [],
                backOrderQty: 0,
                isDuplicatedProduct: false,
                additionalFeeType: product?.additionalFeesId ? additionalFees?.find((a) => a?.id == product?.additionalFeesId) : null,
                additionalFee: product?.additionalRate ?? 0,
                additionalFeeAmount: product?.additionalAmount ?? 0,
                minPrice: 0,
                minBaseSubtotal: 0,
                productSubTax: product?.opportunityProductSubTax ?? [],
            };
        });
    }

    convertBundleProductsToDetails = (product, discountOptions, additionalFees) => {
        return product.opportunityBundleProducts.map((bundleProduct) => {
            const unit = bundleProduct?.uom?.find((uom) => uom.unitOfMeasureId == bundleProduct.uomId);
            return {
                id: bundleProduct?.subProductId,
                uuid: uuidv4(),
                itemNo: bundleProduct?.itemNo ?? "",
                description: bundleProduct?.description ?? "",
                uom: bundleProduct?.uom ?? null,
                unit: unit ?? null,
                availabel: bundleProduct?.product?.availableQty ?? 0,
                ordQty: bundleProduct?.orderQty ?? 0,
                bundleQty: 1, 
                originalQty: 1,
                cost: bundleProduct?.price ?? 0,
                baseprice: bundleProduct?.price ?? 0,
                price: bundleProduct?.price ?? 0,
                originalprice: bundleProduct?.price ?? 0,
                accountPriceTier: bundleProduct?.accountProductPriceTiers ?? [],
                isCustom: bundleProduct?.isCustom ?? false,
                discountTypeName: bundleProduct?.discountTypeName ?? "",
                selectedTierId: bundleProduct?.selectedtierId ?? 0,
                locationId: bundleProduct?.warehouseId ?? 0,
                typeId: bundleProduct?.productTypeId ?? 0,
                discountType: bundleProduct?.discountId ? discountOptions?.find((d) => d.id == bundleProduct?.discountId) : null,
                discount: bundleProduct?.discountRate ?? 0,
                discountAmount: bundleProduct?.discountAmount ?? 0,
                taxType: null,
                taxAmount: 0,
                bundleDetails: [],
                allBundleProducts: [],
                invoiceProductSerialDetails: [],
                totalAvailInSelectedWareHouse: 0,
                totalQuantity: bundleProduct?.totalQty ?? 0,
                productCategory: bundleProduct?.productCategory || [],
                addQty: bundleProduct?.addQty || 0,
                costPrice: bundleProduct?.costPrice ?? 0,
                totalCostPrice: bundleProduct?.totalCostPrice ?? 0,
                trackingEnabled: bundleProduct?.isTrackingRequired ?? false,
                warehouseId: bundleProduct?.warehouseId ?? 0,
                binDetails: bundleProduct?.binDetail ?? [],
                backOrderQty: 0,
                isDuplicatedProduct: false,
                additionalFeeType: bundleProduct?.additionalFeesId ? additionalFees?.find((a) => a?.id == bundleProduct?.additionalFeesId) : null,
                additionalFee: bundleProduct?.additionalRate ?? 0,
                additionalFeeAmount: bundleProduct?.additionalAmount ?? 0,
                minPrice: 0,
                minBaseSubtotal: 0,
                bundleDetailSubTax: bundleProduct?.opportunityBundleDetailSubTax ?? [],
            };
        });
    };
}
